// Theme-dependent chart chrome shared by every ECharts option builder.

export const isDarkTheme = (theme) => theme === 'dark' || theme === true;

// Axis lines / grid lines.
export const axisColor = (theme) => (isDarkTheme(theme) ? 'rgba(255,255,255,0.16)' : 'rgba(0,0,0,0.12)');

// Opacity applied to the non-selected marks while a cross-filter selection is active.
export const DIM_OPACITY = 0.3;

// One tooltip line with a colour swatch.
export const tooltipRow = (color, label, value) =>
  `<span style="display:inline-block;margin-right:6px;border-radius:50%;width:10px;height:10px;background-color:${color};"></span>${label}: <strong>${value}</strong>`;
